import React,{useState} from "react";
import fire from "./assets/fire.png";
import redfire from "./assets/fire-on.png";
import useCountdown from "../../../hooks/useCountDown";
import axios from 'axios';
import RaiseModal from "../../../GlobalComponents/RaiseModal/RaiseModal";
import Popup from "reactjs-popup";
import { useAccount } from "wagmi";


const Card = ({
  thum,
  profile,
  access,
  participants,
  block,
  status,
  raisedAmountMin,
  raisedAmountMax,
  progress,
  title,
}) => {
  const [fireon, setFireon] = useState(0);
  const [firecount, setFireCount] = useState(0);
  var { address } = useAccount();
  const [openBid, setOpenBid] = useState(false);

  const checkWallet = async (data) => {
    try {
      const response = await axios.post('http://localhost:5000/api/check', { data:data });
      const exists = response.data.exists;
      return exists;
    } catch (error) {
      console.error('Error checking wallet:', error);
      throw error;
    }
  };
  const getCount = async (data) => {
    try {
      const response = await axios.post('http://localhost:5000/api/count', {
        data: data,
      });
      const count = response.data.count;
      return count;
    } catch (error) {
      console.error('Error getting count:', error);
      throw error;
    }
  };
  const insertData = async (data) => {
    try {
      const response = await axios.post('http://localhost:5000/api/like', {
        data: data,
      });
  
      const message = response.data.message;
      return message;
    } catch (error) {
      console.error('Error inserting data:', error);
      throw error;
    }
  };
  const deleteData = async (data) => {
    try {
      const response = await axios.post('http://localhost:5000/api/delete', {
          data: data,
      });

      const message = response.data.message;
      return message;
    } catch (error) {
      console.error('Error deleting data:', error);
      throw error;
    }
  };
  const onClickButton = async () => {
    if(!address)
      return;
    try {
      if (fireon) {
        const dataToDelete = {
          id: 0, // Replace with the actual ID
          wallet: address, // Replace with the actual wallet
          type: 'Project', // Replace with the actual type
        };
        await deleteData(dataToDelete);
        console.log("Deleted successfully");
  
      } else {
        const dataToInsert = {
          id: 0, // Replace with the actual ID
          type: 'Project', // Replace with the actual type
          wallet: address, // Replace with the actual wallet
        };
        await insertData(dataToInsert);
        console.log("Inserted successfully");
      }
  
      const dataToCount = {
        id: 0, // Replace with the actual ID
        type: "Project" // Replace with the actual type
      };
      const count = await getCount(dataToCount);
      setFireCount(count);
      console.log("Count fetched successfully");
  
      setFireon(!fireon);
    } catch (error) {
      console.error('Error:', error);
      // Handle the error
    }
  };
  const Initialize = async () => {
    try {
      const dataToCount = {
        id: 0, // Replace with the actual ID
        type: "Project" // Replace with the actual type
      };
      const count = await getCount(dataToCount);
      setFireCount(count);
      console.log("Count fetched successfully");
  
      const dataToCheck = {
        id: 0,
        type: "Project",
        wallet: address, // Replace with the actual wallet address
      };
      const exists = await checkWallet(dataToCheck);
      setFireon(exists ? 1 : 0);
      console.log("Wallet checked successfully");
    } catch (error) {
      console.error('Error:', error);
      // Handle the error
    }
  };
  Initialize();
  const handleDetails = () =>{
    setOpenBid(true);
  }
  return (
    <div className="grow flex justify-center border-2 border-transparent hover:border-main-green rounded-[10px] transition-all">
      <div className="bg-main-black rounded-[10px] max-w-[400px] w-full">
        <div className="pt-[18px] px-[13px]  flex justify-center">
          <div className="relative w-full" style={{paddingBottom:"75%"}}>
            <img className="absolute w-full" style={{top:"0",left:"0",width:"100%",height:"100%",objectFit: "cover"}} src={thum} alt="" />
            <div className="absolute  flex justify-center items-center  bottom-0 rounded-b-[10px] w-full h-[30px] bg-main-green">
              <h2 className="text-[#0E0E0E] text-[18px] leading-[21px] font-semibold">
                {title}
              </h2>
            </div>
            <div className="absolute bottom-[8px] left-[17px]">
              <img style={{width:"75px",height:"75px",borderRadius:"50%"}} src={profile} alt="" />
            </div>
          </div>
        </div>
        <div className="mt-[17px] pl-[20px] pr-[20px] md:pl-[33px] md:pr-[35px]">
          <ul>
            <li className="flex justify-between text-res-xs font-semibold mb-[10px]">
              <h6>Access Tier</h6>
              <p className="text-bright-green">{access}</p>
            </li>
            <li className="flex justify-between text-xs font-semibold mb-[10px]">
              <h6>Participants</h6>
              <p className="text-bright-green">participant</p>
            </li>
            <li className="flex justify-between text-xs font-semibold mb-[10px]">
              <h6>Blockchain</h6>
              <p className="text-bright-green">{block}</p>
            </li>
            <li className="flex justify-between text-xs font-semibold mb-[20px]">
              <h6>Raise Date</h6>
              <p className="text-bright-green lowercase">{status}</p>
            </li>
          </ul>
          <div className="pb-[23px]">
            <h4 className="text-res-xs font-semibold mb-[5px]">
              Raised Amount
            </h4>
            <p className="text-res-xs font-semibold mb-[8px] ">
              <span className="text-bright-green ">{raisedAmountMin} </span> /{" "}
              {raisedAmountMax}
            </p>
            <div className="mb-[19px] h-[9px] relative max-w-100 rounded-full overflow-hidden">
              <div className="w-full h-full bg-light-black absolute"></div>
              <div
                id="bar"
                className="h-full bg-bright-green relative "
                style={{ width: progress || "50%" }}
              ></div>
            </div>
            <div className="flex justify-between">
              <button onClick={handleDetails} className="bg-bright-green  w-[128px] h-[30px] flex justify-center items-center p-[8px] rounded-[20px]">
                <span className=" font-bold text-[15px] leading-[18px] text-light-black">
                  View Details
                </span>
              </button>

              <button onClick={onClickButton} className="bg-main-green flex w-[150px] justify-center items-center gap-[10px] text-res-xxs font-bold text-main-black h-[30px] rounded-[13px]">
                <img className="w-[20px] h-[20px] mb-1" src={fireon?redfire:fire} alt="" />
                <span className=" leading-[24px] w-[94 px]">
                  {firecount}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <>
        <Popup open={openBid} position="right center">
          <div className="modalOverlay"></div>
          <RaiseModal
            thum={thum}
            open={openBid}
            setOpen={setOpenBid}
            profile={profile}
            access={access}
            participants={participants}
            block={block}
            status={status}
            raisedAmountMax={raisedAmountMax}
            raisedAmountMin={raisedAmountMin}
            progress={progress}
            title={title}
          ></RaiseModal>
        </Popup>
      </>
    </div>
  );
};

export default Card;
